import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Quotation from "../../entity/emergency/Quotation";
import useEmergencyInterventionDemoServer
    from "../../component/private/intervention/emergency/demo/useEmergencyInterventionDemoServer";

const SERVICE = "service-emergency";
const ENTITY = "quotations";

/**
 * @rule-checker exclude
 * @returns {*|void|boolean|Promise<*|null|undefined>|{select(): (null|*), exec(): (undefined|*|void|null|boolean)}|{findOneById(*): {select(): (null|*), exec(): (undefined|*|void|null|boolean)}}|null}
 */
export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new Quotation(data);
    const demo = useEmergencyInterventionDemoServer();

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "id", id);
                    }

                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7");
                }
            }
        }
    }
}